module.exports = __webpack_public_path__ + "img/q.540f1851.png";